module.exports = __webpack_public_path__ + "static/media/J24-Desktop-Banner.43e41192.jpg";